import React from 'react'
import classNames from 'classnames'
import { ExclamationCircleIcon } from '@heroicons/react/24/solid'
import type { UseFormRegisterReturn, FieldErrors } from 'react-hook-form'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string
  // Optional so the component can also be used controlled (value/onChange)
  // outside a react-hook-form context, while existing RHF callers keep
  // passing register + errors unchanged.
  register?: Partial<UseFormRegisterReturn>
  errors?: FieldErrors
  prefix?: string
  postfix?: string
  containerClass?: string
  step?: string | number
}

const Input = (props: InputProps) => {

  const {
    name,
    register = {},
    type = 'text',
    errors = {},
    prefix,
    postfix,
    className,
    containerClass = 'sm:max-w-xs',
    step = 'any',
    ...otherProps
  } = props
  const classes = classNames(
    'max-w-lg block w-full shadow-xs pr-10 pl-7 sm:text-sm rounded-md',
    {
      'border-cerise-red-300 text-cerise-red-900 placeholder-red-300 focus:outline-hidden focus:ring-cerise-red focus:border-cerise-red': errors[name],
      'focus:ring-perfect-shine focus:border-perfect-shine block w-full border-gray-300': !errors[name],
    },
    className,
  )

  return (
    <div className={`flex flex-col ${type === 'hidden' ? 'hidden' : ''}`}>
      <div className={`relative ${containerClass}`}>
        {prefix && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">{prefix}</span>
          </div>
        )}
        <input
          {...otherProps}
          {...register}
          type={type}
          className={classes}
          {...(type === 'number' ? { step } : {})}
        />
        {(postfix || errors[name]) && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none space-x-1">
            {postfix && (
              <span className="text-gray-500 sm:text-sm">
                                {postfix}
                            </span>
            )}
            <div className="h-5 w-5">
              {errors[name] && (
                <ExclamationCircleIcon className="text-cerise-red-500" aria-hidden="true"/>
              )}
            </div>
          </div>
        )}
      </div>

      <p className="mt-2 text-sm text-cerise-red-600 select-none min-h-5">
        {(errors?.[name]?.message as string) || ''}
      </p>

    </div>
  )
}

export default Input
